import React, { useState } from "react";

export default function CurrencyInput({ value, onChange, placeholder }) {
  const [internalValue, setInternalValue] = useState(value || "");

  // ✅ Quand l'utilisateur tape
  const handleChange = (e) => {
    setInternalValue(e.target.value); // garde la saisie temporaire
    onChange(e.target.value); // envoie brut au parent
  };

  // ✅ Quand l'utilisateur quitte le champ
  const handleBlur = () => {
    if (internalValue === "" || isNaN(internalValue)) {
      setInternalValue("");
      onChange("");
      return;
    }

    const formatted = parseFloat(internalValue).toFixed(2);
    setInternalValue(formatted);
    onChange(formatted);
  };

  return (
    <div style={styles.wrapper}>
      <input
        type="number"
        step="0.01"
        value={internalValue}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        style={styles.input}
      />
      <span style={styles.symbol}>€</span>
    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    position: "relative",
  },
  input: {
    flex: 1,
    padding: "10px 30px 10px 10px", // espace pour le symbole €
    fontSize: 16,
    borderRadius: 4,
    border: "1px solid #ccc",
  },
  symbol: {
    position: "absolute",
    right: 10,
    color: "#666",
    fontSize: 16,
  },
};
